import _ from "lodash";
import React from "react";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { Button } from "../../../components";
import { Modal } from "react-bootstrap";
import { ModalConfirmation } from "../../../types/DefModalOptions";
import { Controller, useForm } from "react-hook-form";
import { FormSelect } from "../../../components/forms";
import { GenericUserSelect } from "../../../components/forms/selects";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export type CreateSubscriptionForm = {
    userId: string
    type: number
};

export type CreateSubscriptionModalProps = ModalConfirmation<CreateSubscriptionForm>;
const CreateSubscriptionModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
}: Readonly<CreateSubscriptionModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const { control, formState: { errors }, handleSubmit, reset, setValue } = useForm<CreateSubscriptionForm>();

    const onClose = () => cancel!();

    const onSubmit = (form: CreateSubscriptionForm) => proceed!(form);

    React.useEffect(() => {
        if (_.isEmpty(defaultValues)) {
            return;
        }
        reset({ ...defaultValues });
    }, [ defaultValues ]);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Create a new Subscription</Modal.Title>
            </ThemedModal.Header>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body ref={bodyAnimation}>
                    <div className="row gy-2">
                        <div className="col-6">
                            <Controller
                                name="userId"
                                control={control}
                                rules={{ required: 'A user must be selected' }}
                                render={({ field: { ref, value, onChange, ...rest } }) => (
                                    <GenericUserSelect
                                        label="User"
                                        defaultValue={value}
                                        disableAnimations={true}
                                        errorMessage={errors?.userId?.message}
                                        errorAllowRetry={false}
                                        onChange={(values: any) => setValue('userId', values.value)}
                                        {...rest}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-6">
                            <Controller
                                name="type"
                                control={control}
                                rules={{ required: 'Type of subscription must be selected' }}
                                render={({ field: { ref, value, onChange, ...rest } }) => (
                                    <FormSelect
                                        label="Subscription Type"
                                        options={[
                                            { label: 'Mailbox Notifications', value: 0 }
                                        ]}
                                        defaultValue={value}
                                        disableAnimations={true}
                                        errorMessage={errors?.type?.message}
                                        errorAllowRetry={false}
                                        onChange={(values: any) => setValue('type', values.value)}
                                        {...rest}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" type="submit">Create Subscription</Button>
                    <Button variant="light" onClick={onClose}>Cancel</Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export function openCreateSubscriptionModal(opts: CreateSubscriptionForm = { userId: '', type: 0 }) {
    return createConfirmation<CreateSubscriptionModalProps, CreateSubscriptionForm>(confirmable(CreateSubscriptionModal))({
        dialogId: 'create_subscription_modal',
        defaultValues: opts
    });
}